import type { Axios } from 'axios';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';

export type CalendarSettings = {
	titleDisplay: 'customer' | 'sessionName';
	paxDisplay: 'remaining' | 'current' | 'currentAndCapacity' | 'hidden';
	showTimeslot: 'all' | 'start' | 'end' | 'hidden';
	thirdRowDisplay: 'privateNote' | 'customerRequest' | 'hidden';
	showGauge: boolean;
	showCustomerRequest: boolean;
	showPrivateNote: boolean;
	showRemainingPayment: boolean;
	showOrigin: boolean;
	showOffer: boolean;
	background: 'customer' | 'session' | 'sessionImage' | 'booking' | '' | 'offer';
	cash: 'total' | 'remaining';
};
export const agendaSettingStore = writable<CalendarSettings>({
	showGauge: true,
	titleDisplay: 'customer',
	paxDisplay: 'remaining',
	showTimeslot: 'all',
	showCustomerRequest: true,
	showPrivateNote: true,
	showRemainingPayment: true,
	showOrigin: true,
	showOffer: true,
	thirdRowDisplay: 'privateNote',
	background: 'booking',
	cash: 'remaining'
});

export function loadAgendaSettings() {
	(get(apiStore) as Axios)
		.get('/business/agenda-settings')
		.then((res) => loadAgendaSettingsFromData(res.data));
}

export function loadAgendaSettingsFromData(data: CalendarSettings) {
	agendaSettingStore.set(data);
}
